<div class="setting-account-cnt">
  <div class="alert alert-success success-msg" *ngIf="_resetDataCompleted || _resetNetworkCompleted">
    <div>
      <ng-lottie width="30px" [options]="options"></ng-lottie>
    </div>
    <div *ngIf="_resetDataCompleted">&nbsp;&nbsp;&nbsp;Resetting your data is completed !</div>
    <div *ngIf="_resetNetworkCompleted">&nbsp;&nbsp;&nbsp;Resetting your network connections is completed !</div>
  </div>
  <!-- ! Reset Account -->
  <div class="reset-data-cnt">
    <h2 class="section-sub-title">Reset Data</h2>
    <div class="hint">
      <p class="section-hint">
        Resetting your data will remove all your words, pairs, dictionaries and saved items in bookmarks and
        collections.
      </p>
    </div>
    <ddc-button-s-two
      class="reset-data-btn"
      [_isLoading]="false"
      [_label]="'Reset Data'"
      (click)="resetDataDialog()"
    ></ddc-button-s-two>
  </div>
  <mat-divider></mat-divider>
  <!-- ! Reset Network -->
  <div class="reset-network-cnt">
    <h2 class="section-sub-title">Reset Network</h2>
    <div class="hint">
      <p class="section-hint">
        Resetting your network will remove all your network connections with followers and following.
      </p>
    </div>
    <ddc-button-s-two
      class="reset-network-btn"
      [_isLoading]="false"
      [_label]="'Reset Network'"
      (click)="resetNetworkDialog()"
    ></ddc-button-s-two>
  </div>
  <mat-divider></mat-divider>

  <!-- ! Reset Network -->
  <div class="reset-network-cnt">
    <h2 class="section-sub-title">Delete Account</h2>
    <div class="hint">
      <p class="section-hint">Deleting your account will remove all your data and cannot be undone.</p>
    </div>
    <ddc-button-s-two
      class="reset-network-btn"
      [_isLoading]="false"
      [_label]="'Delete Account'"
      (click)="deleteAccountDialog()"
    ></ddc-button-s-two>
  </div>
</div>
